import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import 'rxjs/add/operator/map';

import { TableConfig } from "@app/shared/util/table-config.utils";
import { AppUtils } from "@app/shared/util/app.utils";

import { environment } from 'environments/environment';
import { ToolTransport } from "@models/tool-transport.model";
import { ToolRequestsService } from "@services/tool-requests.service";
import { Subject } from "rxjs";
import { ToolReturnsService } from "@services/tool-returns.service";
import { map } from "rxjs/operators";

/**
 * Service class for handling CRUD operations on {@link ToolTransport} objects.
 */
@Injectable()
export class ToolTransportService {
    static readonly API_TOOL_LINE_BASE_PATH = `${environment.baseURL}/api/requests/line`;
    static readonly API_TOOL_ATOM_BASE_PATH = `${environment.baseURL}/api/requests/atom`;


    private loadEvent = new Subject<any>();
    public loadEventObservable = this.loadEvent.asObservable();

    constructor(private http: HttpClient) {
    }

    /**
     * Get Requests from LINE
     * */
    getLineRequests(filter: TableConfig, type = 'LINE') {
        let params = AppUtils.buildPageableParamsFromList(filter);
        params = params.set('type', type);

        return this.http.get<any>(`${ToolTransportService.API_TOOL_LINE_BASE_PATH}`,
            {params: params}
        ).pipe(map(this.mapToolTransport));

    }

    /**
     * Get Requests from ATOM
     * */
    getAtomRequests(filter: TableConfig, type = 'LINE') {
        let params = AppUtils.buildPageableParamsFromList(filter);
        params = params.set('type', type);

        return this.http.get<any>(`${ToolTransportService.API_TOOL_ATOM_BASE_PATH}`,
            {params: params}
        ).pipe(map(this.mapToolTransport));
    }

    loadToolTransportForRequest(transportId: number) {
        return this.http.patch<ToolTransport>(`${ToolRequestsService.API_TOOL_REQUESTS_BASE_PATH}/${transportId}/load`, null);
    }

    unloadToolTransportForRequest(transportId: number) {
        return this.http.patch<ToolTransport>(`${ToolRequestsService.API_TOOL_REQUESTS_BASE_PATH}/${transportId}/unload`, null);
    }

    loadToolTransportForReturn(transportId: number) {
        return this.http.patch<ToolTransport>(`${ToolReturnsService.API_TOOL_RETURNS_BASE_PATH}/${transportId}/load`, null);
    }

    unloadToolTransportForReturn(transportId: number) {
        return this.http.patch<ToolTransport>(`${ToolReturnsService.API_TOOL_RETURNS_BASE_PATH}/${transportId}/unload`, null);
    }

    private mapToolTransport = res => {
        return {
            items: res.items.map(toolTransport => new ToolTransport(toolTransport)),
            total: res.total
        };
    };


}
